import React from 'react'
import PropTypes from 'prop-types'
import { required } from 'components/global/form/FormValidations'
import { useForm } from 'react-final-form'
import I18n from 'translations/i18n'
import { FileUpload, Flex } from '@jisr-hr/design-system'
import { SelectField, TextInputField } from 'components/final-form'
import Frame from 'components/global/templates/RequestDrawer/ds/Frame'

import Styles from './Reason.module.css'

const reasonTypes = [
  { value: 'Personal', label: I18n.t('ex_personal') },
  { value: 'Business', label: I18n.t('ex_business') },
]

const Reason = ({ showReasonType, hideReason, hideFileUpload, isRequired }) => {
  const { change } = useForm()

  return (
    <Frame title={I18n.t('reason')}>
      <Flex
        flexCol
        style={{ gap: '16px' }}
      >
        {showReasonType && (
          <SelectField
            name="reason_type"
            options={reasonTypes}
            validate={required}
            testId="reason-type"
          />
        )}
        {!hideReason && (
          <>
            <TextInputField
              testId="requests-reason"
              placeholder={I18n.t('enter_your_reason')}
              name="reason"
              validate={(v) => (isRequired ? required(v) : undefined)}
            />
            {!hideFileUpload && (
              <FileUpload
                onLoad={(files) => {
                  const attachments = files?.map((val) => ({
                    data: val?.file,
                    filename: val?.name,
                  }))
                  change('attachments', attachments)
                }}
                multiple
                keepPrevious
                hasDeleteButton
                errorMessage="Unable to upload file"
                loadingMessage="Uploading file"
                message={I18n.t('add_attatchment')}
                successMessage={I18n.t('file_selected')}
                uploadingMessage="Uploading in Progress"
                className={Styles.fileUpload}
              />
            )}
          </>
        )}
      </Flex>
    </Frame>
  )
}

Reason.defaultProps = {
  isRequired: false,
}

Reason.propTypes = {
  hideReason: PropTypes.bool,
  hideFileUpload: PropTypes.bool,
  showReasonType: PropTypes.bool,
  isRequired: PropTypes.bool,
}

export default Reason
